import { apiRTK, Tag } from 'api/api-rtk'

import type * as API from './types'

export const api = apiRTK.injectEndpoints({
	endpoints: create => ({
		importById: create.query<API.ImportResponse, string>({
			providesTags: (result, _, id) =>
				result ? [{ id, type: Tag.Imports }] : [Tag.Imports],
			query: id => ({
				url: `imports/${id}`
			})
		}),

		recents: create.query<API.ImportResponse[], void>({
			async onQueryStarted(_, { dispatch, queryFulfilled }) {
				try {
					const { data } = await queryFulfilled
					for (const item of data) {
						const action = api.util.upsertQueryData('importById', item.id, item)
						dispatch(action)
					}
				} catch (error) {
					return
				}
			},

			providesTags: result =>
				result?.map(({ id }) => ({ id, type: Tag.Imports })) || [Tag.Imports],
			query: () => ({
				url: 'imports/recent'
			})
		}),
		update: create.mutation<API.ImportResponse, API.Updatebody>({
			async onQueryStarted(item, { dispatch, queryFulfilled }) {
				const single = api.util.updateQueryData(
					'importById',
					item.id,
					draft => {
						draft.name = item.name
					}
				)

				const recents = api.util.updateQueryData(
					'recents',
					undefined,
					draft => {
						const found = draft.find(({ id }) => id === item.id)

						if (found) {
							found.name = item.name
						}
					}
				)

				const patchSingle = dispatch(single)
				const patchRecents = dispatch(recents)

				try {
					await queryFulfilled
				} catch (error) {
					// @ts-ignore TODO: open issue on lib
					patchSingle.undo()
					// @ts-ignore TODO: open issue on lib
					patchRecents.undo()
					console.error(error)
				}
			},

			query: ({ id, name }) => ({
				data: {
					name
				},
				method: 'PUT',
				url: `imports/${id}`
			})
		})
	}),
	overrideExisting: true
})
